// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"K7-z"};